/** Base URL for ticketing API (no trailing slash), e.g. https://dev.newapi.airoi.com/ticketing */
export function getTicketingApiBase() {
  return (process.env.REACT_APP_TICKETING_API_URL || '/api/ticketing').replace(/\/$/, '');
}

/**
 * Join API base with a relative path from the API (/v1/... or legacy /ticketing/v1/...).
 */
export function resolveTicketingApiUrl(path) {
  if (!path) return getTicketingApiBase();
  if (path.startsWith('http')) return path;
  const base = getTicketingApiBase();
  let normalized = path.startsWith('/') ? path : `/${path}`;
  if (base.endsWith('/ticketing') && normalized.startsWith('/ticketing/')) {
    normalized = normalized.slice('/ticketing'.length);
  }
  return `${base}${normalized}`;
}
